










































import Vue, { PropType } from "vue";
import { EhrModule } from "../../types/general/EhrModule";
import { EhrNotification } from "../../types/general/EhrNotification";
import { EhrNotificationAction } from "../../types/general/EhrNotificationAction";
import { RepositoryFactory } from "./../repositories/RepositoryFactory";

const NotificationsRepository = RepositoryFactory.get("notifications");
export default Vue.extend({
  name: "notification-center",
  props: {
    modules: {
      type: Array as PropType<EhrModule[]>,
      default: []
    }
  },
  mounted() {
    this.getNotifications();
  },
  data() {
    return {
      notifications: [] as EhrNotification[],
    };
  },
  methods: {
    async getNotifications() {
      const { data } = await NotificationsRepository.getNotifications();
      if (data) {
        this.notifications = this.resultToNotificationObject(data);
      }
    },
    resultToNotificationObject(notifications): EhrNotification[] {
      return notifications.map((notification) => {
        if (!this.modules) return;
        const module = this.modules.find(module => module.module === notification.ehrModule);
        if (!module) throw new Error(`Invalid notification module ${notification.ehrModule}.`);
        return {
          id: notification.id,
          needsResolve: notification.needsResolve,
          action: notification.notificationAction,
          message: notification.message,
          icon: notification.icon,
          read: notification.isSeen,
          modulePath: module.path,
          moduleName: module.name,
          date: notification.created,
        } as EhrNotification;
      });
    },
    async redirectNotification(notification: EhrNotification) {
      if (!notification.needsResolve) {
        var idsToMarkAsRead = [] as number[];
        idsToMarkAsRead.push(notification.id);
        await this.markReadToDb(idsToMarkAsRead);
      }
      if (this.isNotificationRedirectToModule(notification)) {
        window.location.href = document.baseURI + notification.modulePath;
      }
    },
    isNotificationRedirectToModule(notification: EhrNotification) {
      return notification.action === EhrNotificationAction.RedirectToModule;
    },
    markAllInformationalAsRead(): void {
      let ids = [] as number[];
      this.notifications.forEach((notif) => {
        if (!notif.read) {
          ids.push(notif.id);
        }
      });
      this.markReadToDb(ids);
    },
    async markReadToDb(arrayOfIds) {
      if (arrayOfIds.length) {
        let res = await NotificationsRepository.markAsRead(arrayOfIds).then(
          (resp) => {
            this.notifications = this.notifications.map((element) => {
              if (arrayOfIds.includes(element.id)) {
                element.read = true;
              }
              return element;
            });
          }
        );
      }
    },
    async resolveNotification(index) {
      let notifToResolve = this.notifications[index];
      if (!notifToResolve.needsResolve) {
        let res = await NotificationsRepository.resolveNotification(
          notifToResolve.id
        ).then((resp) => {
          this.notifications.splice(index, 1);
        });
      }
    },
  },
  watch: {
    notifications(newArray, oldArray): void {
      this.$emit("notifications-changed", newArray);
    },
    update(newVal, oldVal): void {
      this.markAllInformationalAsRead();
    },
  },
});
